'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { useMobileSearch } from '@eliadmin/core/src/components/header/mobile-search';
import { useRef } from 'react';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ButtonIcon } from '../ui/button-icon';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
};

export function SearchButton(props: SearchButtonProps) {
  const { className, ...buttonProps } = props;
  const { t } = useTranslations();
  const sharedOpen = useMobileSearch((s) => s.isOpen);
  const toggle = useMobileSearch((s) => s.toggle);
  const sharedOpenRef = useRef(sharedOpen);
  sharedOpenRef.current = sharedOpen;
  const notifyOpen = (next: boolean) => {
    if (sharedOpenRef.current === next) return;
    sharedOpenRef.current = next;
    toggle();
  };
  return (
    <SearchDrawer
      onOpenChange={notifyOpen}
      trigger={
        <Button
          type="button"
          {...buttonProps}
          className={cn('ea-search-button', className?.root)}
          size="none"
          variant={'none'}
          aria-label={t('text1')}
        >
          <ButtonIcon
            alt="Hľadať"
            url="/images/icons/search-button.svg"
            className="max-h-6 min-h-6 min-w-6 max-w-6"
          />
        </Button>
      }
    />
  );
}
